module.exports = __webpack_public_path__ + "img/file-icon.505069dc.svg";